import { all, fork, select, call, put, takeEvery } from 'redux-saga/effects';
import * as actions from './actions';
import * as API from './api';
import { getKeystore } from './selectors';

export function* setKeystoreItem({ payload: { key, value } }) {
  const keyStore = yield select(getKeystore);
  const originalValue = keyStore.get(key);

  // no point making the request to set it if it's the same
  if (originalValue === value) {
    return;
  }

  yield put(actions.setKeystoreItem.request(key, value));

  const response = yield call(API.setKeystoreItem, key, value);

  if (response.ok) {
    yield put(actions.setKeystoreItem.success(key, value));
  } else {
    yield put(
      actions.setKeystoreItem.failure(
        response.failureReason,
        key,
        originalValue
      )
    );
  }
}

export function* watchSetKeystoreItem() {
  yield takeEvery(actions.SET_KEYSTORE_ITEM_SIGNAL, setKeystoreItem);
}

export default function* profileSagas() {
  yield all([fork(watchSetKeystoreItem)]);
}
